import React, { FC } from 'react';
import { connect } from 'react-redux';
import { ExtendedRootState } from '../common/interfaces';
import ControlCenter from './ControlCenter';
import SessionInfo from './SessionInfo';

interface ControlCenterPageProps {
    connectSession: boolean;
    unifiedPlatform: boolean;
}

const ControlCenterPage: FC<ControlCenterPageProps> = ({ connectSession, unifiedPlatform }) =>
    connectSession ? <ControlCenter /> : <SessionInfo unifiedPlatform={unifiedPlatform} />;

export default connect((state) => {
    const { user = {} } = state as ExtendedRootState;
    const { connectSession, unifiedPlatform } = user;

    return {
        connectSession,
        unifiedPlatform,
    };
})(ControlCenterPage);
